import axios from 'axios';
import apiroutes from '@/API/ApiRoutes';


const state = {};

const getters = {};

const actions = {
  DonorUpadate({commit}, payload) {
    return new Promise((resolve, reject) => {
      let dataForUpdate ={
        blood_group_id: payload.blood_group.id,
        weight: payload.weight,
        height: payload.height,
        last_donate: payload.last_donate

      };
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth){
        tok= 'Bearer '+auth.access_token;
      }else{
        tok= '';
      }
      let authheader = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        Authorization : tok
      };
      let id = JSON.parse(localStorage.getItem('user-response'));
      axios.patch(apiroutes.routes.register +'/'+payload.partial_user.id+apiroutes.routes.postDonor, dataForUpdate,
        {headers: authheader})
        .then((response) => {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  DonorProfileInfoUpdate({commit}, payload) {
    return new Promise((resolve, reject) => {
      let userDataForUpdate ={
        name: payload.partial_user.name,
        picture_path: payload.partial_user.picture_path,
        gender_id: payload.gender,
        date_of_birth: payload.partial_user.date_of_birth

      };
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth){
        tok= 'Bearer '+auth.access_token;
      }else{
        tok= '';
      }
      let authheader = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        Authorization : tok
      };
      let id = JSON.parse(localStorage.getItem('user-response'));
      axios.patch(apiroutes.routes.register +'/'+payload.partial_user.id+apiroutes.routes.profile, userDataForUpdate,
        {headers: authheader})
        .then((response) => {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

};
const mutations = {};
export default {
  state,
  getters,
  actions,
  mutations
};
